"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onContentLoaded = exports.onLoad = void 0;
var callbacks = [];

var hasRun = function hasRun() {
  return document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll;
};
/**
 * Registers a callback to be called when the page is loaded and ready
 * @param {function} callback
 * @example
 *
 * import { onLoad } from '@demant/wdh';
 *
 * onLoad(() => {
 *   // Code executes when the page is loaded and ready
 * });
 */


var onLoad = function onLoad(callback) {
  if (hasRun()) {
    try {
      callback();
    } catch (err) {
      console.log('Error', err);
    }
  } else {
    // add to callbacks array
    callbacks.push(callback);
  }
};

exports.onLoad = onLoad;

var executeCallbacks = function executeCallbacks() {
  setTimeout(function () {
    var len = callbacks.length;

    for (var i = 0; i < len; i += 1) {
      var callback = callbacks[i];

      try {
        callback();
      } catch (err) {
        console.log('Error', err);
      }
    }
  }, 0);
};

var onContentLoaded = function onContentLoaded(callback) {
  onLoad(callback);
};

exports.onContentLoaded = onContentLoaded;

if (!hasRun()) {
  document.addEventListener('DOMContentLoaded', executeCallbacks);
}